export const parseEvalString = (
  code: string,
  data?: Record<string, unknown>,
) => {
  try {
    // eslint-disable-next-line no-new-func
    const func = new Function("data", `return ${code}`);
    return func(data);
  } catch (err) {
    console.error(`Failed to evaluate code: ${code}`, err);
    return false;
  }
};
